/* eslint-disable no-alert */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  Card, CardBody, CardTitle, Col, Row, Form, FormGroup, Label, Input, Button, Spinner,
} from 'reactstrap';
import toastr from 'toastr';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { post } from '../../helpers/api_helper';

function PayOnUse(props) {
  const [count, setCount] = useState(1);
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState([]);
  const { t } = props;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const data = await post('/api/orders/ship/pour-labels', { count: parseInt(count, 10) || 1 });
      setResults(data.labels || []);
      toastr.success(t('Labels sent to printer'));
    } catch (error) {
      toastr.error(error.message || t('Unable to create labels'), t('Error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-content">
      <Breadcrumbs title={t('Remote Services')} breadcrumbItem={t('USPS Pay-On-Use Returns')} />
      <Row>
        <Col lg="6">
          <Card>
            <CardBody>
              <CardTitle className="mb-4">{t('Print USPS Pay-On-Use Return Labels')}</CardTitle>
              <Form onSubmit={onSubmit}>
                <FormGroup className="mb-3">
                  <Label for="count">{t('Number of labels')}</Label>
                  <Input
                    id="count"
                    name="count"
                    type="number"
                    min="1"
                    value={count}
                    onChange={(e) => setCount(e.target.value)}
                    required
                  />
                </FormGroup>
                <Button color="primary" type="submit" disabled={loading}>
                  {loading ? <Spinner size="sm" /> : 'Print Labels'}
                </Button>
              </Form>
            </CardBody>
          </Card>
        </Col>
        <Col lg="6">
          <Card>
            <CardBody>
              <CardTitle className="mb-4">Recent requests</CardTitle>
              {results.length === 0 && <p className="text-muted mb-0">No labels created yet.</p>}
              {results.length > 0 && (
                <ul className="mb-0">
                  {results.map((label) => (
                    <li key={`${label.tracking_number || 'label'}`}>
                      {label.tracking_number || 'Tracking pending'}
                    </li>
                  ))}
                </ul>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  );
}

PayOnUse.propTypes = {
  t: PropTypes.any,
};

PayOnUse.defaultProps = {
  t: (x) => (x),
};

const mapStateToProps = (state) => ({ ...state.Layout });

export default connect(mapStateToProps, {
})(withTranslation()(PayOnUse));
